import { useCallback } from 'react';
import { useStore, StoreTypes } from 'context';
import Repository from 'repositories/Repository';
import { ReaderToolType } from 'constants/ReaderTools';
import { gaEventReaderToolsClick } from 'components/AppService/GAService';
import { CategoryType } from 'constants/gaEventType';
import useModal from 'components/common/Modal/useModal';
import { ModalComponentGenerator, ModalComponentType } from 'components/common/Modal/ModalComponentGenerator';
const { ExtendedResourceRepository } = Repository;

export const useNumberPickerCommand = () => {
    const [{ bookId }] = useStore(StoreTypes.books);
    const [, { openModal, setModalComponents }] = useModal();

    const execute = useCallback(async () => {
        try {
            gaEventReaderToolsClick({
                category: CategoryType.ReaderTool,
                action: ReaderToolType.NumberPicker,
                label: ReaderToolType.NumberPicker
            });
            // const tools = await ExtendedResourceRepository.getToolbarTools({ bookId }) || [];
            // const numberSelector = tools.filter(item=>item.type && item.type === 'numberSelector');
            // if(numberSelector && numberSelector.length > 0){
            //     const tool = numberSelector[0];
            //     return ExtendedResourceRepository.postTools({ bookId, filename: tool.filename })
            // } else {
            //     window.open('https://select.oneclass.com.tw','blank')
            // }
            
            //window.open('https://select.oneclass.com.tw', 'blank')

            const component = ModalComponentGenerator.generate(ModalComponentType.IFrame, { internalHtmlInfo: { src: process.env.REACT_APP_NUMBER_PICKER_DOMAIN, toolbarOpen:false } });
            setModalComponents(component);
            openModal();

        } catch (e) {
            console.error('NumberPickerCommand execute error', e);
        }
    }, [bookId]);

    return { execute };
};
